var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSettingIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 9.375H8.25C8.10082 9.375 7.95774 9.43426 7.85225 9.53975C7.74676 9.64524 7.6875 9.78832 7.6875 9.9375V19.5C7.6875 19.7984 7.80603 20.0845 8.017 20.2955C8.22798 20.5065 8.51413 20.625 8.8125 20.625H21.1875C21.4859 20.625 21.772 20.5065 21.983 20.2955C22.194 20.0845 22.3125 19.7984 22.3125 19.5V9.9375C22.3125 9.78832 22.2532 9.64524 22.1477 9.53975C22.0423 9.43426 21.8992 9.375 21.75 9.375ZM20.3037 10.5L15 15.3621L9.69633 10.5H20.3037ZM21.1875 19.5H8.8125V11.2165L14.6196 16.5398C14.7234 16.6351 14.8591 16.688 15 16.688C15.1409 16.688 15.2766 16.6351 15.3804 16.5398L21.1875 11.2165V19.5Z",
    fill: "#616E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSettingIcon8);
export default __webpack_public_path__ + "static/media/location_setting_icon8.899a47d11f0d92b7c249fc8e46429c30.svg";
export { ForwardRef as ReactComponent };